import { fetchList, removeItemFromList, fetchLists } from './swym.js'
class WishlistPage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  initWishlistPage () {
    const loggedIn = !!window.ShopifyAnalytics.meta.page.customerId

    if (!loggedIn) {
      window.SwymCallbacks.push(() => {
        fetchLists(false)
          .then(lists => {
            if (lists.length > 0) {
              const list = lists[0]

              this.els.title.element.innerText = `${list.lname} (${list.listcontents.length})`

              this.renderProducts(list.listcontents)
            }
          })
          .catch(err => console.error(err))
      })
    } else {
      const params = new URLSearchParams(window.location.search)
      const name = params.get('name')

      if (name) {
        this.els.title.element.innerText = name
      }

      const lid = params.get('lid')
      this.lid = lid

      this.items = []

      window.SwymCallbacks?.push(() => {
        fetchList(lid).then(list => {
          this.renderProducts(list.listcontents)
          this.items = list.listcontents
        })
      })
    }
  }

  setupListeners () {
    this.els.addAll.element.addEventListener('click', () => {
      this.addAllToBag()
    })

    window.addEventListener('PandectesEvent_OnConsent', e => {
      this.initWishlistPage()
    })
  }

  removeProduct (item, element) {
    const product = {
      epi: item.epi,
      empi: item.empi,
      du: item.du,
    }

    removeItemFromList(this.lid, product)
      .then(() => {
        element.remove()
      })
      .catch(err => {
        console.error(err)
      })
  }

  renderProducts (items) {
    const grid = this.els.grid.element
    grid.innerHTML = ''

    items.forEach(item => {
      const itemUrlSubstring = item.du.substring(item.du.indexOf('/products'))

      BAO.sectionRenderer
        .fetchSingle('product-card', itemUrlSubstring)
        .then(text => {
          const container = document.createElement('div')
          container.innerHTML = text
          container.querySelector('.shopify-section').style.height = '100%'
          container.style.position = 'relative'
          container.dataset.epi = item.epi

          const addToBagButton = container.querySelector(
            '.add-to-bag-button-container',
          )

          const button = document.createElement('button')
          button.classList.add('btn-Button', 'btn-Button-primary')
          button.innerText = 'Add to Bag'
          button.style.width = '100%'
          button.style.paddingBlock = '16px'
          button.style.display = 'flex'
          button.style.justifyContent = 'center'
          button.addEventListener('click', e => {
            this.addProductToBag(container)

            e.preventDefault()
            e.stopPropagation()
          })

          addToBagButton.appendChild(button)

          const variantSelector = container.querySelector(
            '.variant-selector-container',
          )

          BAO.sectionRenderer
            .fetchSingle('variant-selector', itemUrlSubstring)
            .then(text => {
              variantSelector.innerHTML = text

              variantSelector.querySelector('select').value = item.epi
              variantSelector.querySelector(
                'variant-selector',
              ).dataset.variantId = item.epi
            })

          const removeButton = document.createElement('button')
          removeButton.classList.add('wsh-WishlistPage_ProductRemove')
          removeButton.innerHTML = `
            <svg class="wsh-WishlistPage_ProductRemoveIcon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 10">
              <path fill="currentColor" d="m1.695.308 8.975 8.975-.716.716L.979 1.024z"/>
              <path fill="currentColor" d="M10.668.715 1.692 9.691l-.716-.717L9.951 0z"/>
            </svg>
          `
          removeButton.addEventListener('click', e => {
            e.preventDefault()
            e.stopPropagation()

            this.removeProduct(item, container)
          })

          container.appendChild(removeButton)

          grid.appendChild(container)
        })
    })
  }

  async addAllToBag () {
    const removeItems = this.els.addAll.element.dataset.removeItems === 'true'

    const params = new URLSearchParams(window.location.search)
    const lid = params.get('lid')

    const items = this.items.map(item => {
      return {
        id: item.epi,
        quantity: 1,
      }
    })

    const state = await window.BAO.Cart.addItem(items)

    if (removeItems) {
      state.items.forEach(item => {
        const listItem = this.items.find(i => i.epi === item.variant_id)

        const product = {
          epi: listItem.epi,
          empi: listItem.empi,
          du: listItem.du,
        }

        this.items = this.items.filter(i => i.epi !== listItem.epi)

        removeItemFromList(lid, product)

        const cardContainer = document.querySelector(
          `[data-epi="${listItem.epi}"]`,
        )

        if (cardContainer) {
          cardContainer.remove()
        }
      })
    }
  }

  addProductToBag (container) {
    const variantSelector = container.querySelector('variant-selector')

    const variantId = variantSelector.dataset.variantId

    const items = [
      {
        id: variantId,
        quantity: 1,
      },
    ]

    window.BAO.Cart.addItem(items)
  }

  get wishlistLocalStorage () {
    if (typeof Storage !== 'undefined' && localStorage.getItem('swym-lists')) {
      return JSON.parse(localStorage.getItem('swym-lists'))
    }

    return null
  }
}

if (!customElements.get('wishlist-page')) {
  customElements.define('wishlist-page', WishlistPage)
}
